const displayMoney = (value: number) => value.toFixed(2)
const removeZeroPence = (value: string) => value.replace(/\.00$/, '')
const prependPoundSign = (value: string) => '£'.concat(value)
const handleNegativeNumbers = (value: string) => value.replace('£-', '-£')
export const pricePresenterWithPence = (params: number) =>
  handleNegativeNumbers(prependPoundSign(displayMoney(params)))
export const pricePresenter = (params: number) =>
  removeZeroPence(handleNegativeNumbers(prependPoundSign(displayMoney(params))))
